import React from 'react';
export function AboutHero() {
  return <section className="relative pt-24 pb-32 px-4 overflow-hidden" data-id="element-217">
      <div className="absolute inset-0 z-0" data-id="element-218">
        <img src="https://cdn.magicpatterns.com/uploads/8r6ArQH2wF2utmMuU7bAbi/About_Us-hero.jpg" alt="About Northwest Black Belt Academy" className="w-full h-full object-cover object-center" data-id="element-219" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f1f3d]/90 via-[#0f1f3d]/85 to-[#0f1f3d]/90" data-id="element-220"></div>
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-221">
        <div className="space-y-6 animate-fade-in-up" data-id="element-222">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white leading-tight tracking-tight drop-shadow-2xl" data-id="element-223">
            About Northwest Black Belt Academy: Lynnwood, Washington Taekwondo &
            Martial Arts School for Kids, Teens, and Adults
          </h1>
          <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-6" data-id="element-224"></div>
          <p className="text-lg sm:text-xl text-white/95 max-w-3xl mx-auto leading-relaxed drop-shadow-lg" data-id="element-225">
            At Northwest Black Belt Academy, we help students build real-world
            confidence, discipline, and respect through structured Taekwondo
            training in a supportive, family-friendly community. Led by Master
            Joe Whitworth and a dedicated team, our programs meet students where
            they are—and guide them forward, one goal at a time.
          </p>
        </div>
      </div>
    </section>;
}